"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nBins = 20;



//////////////////
// WEBPACK FOOTER
// ./src/config.ts
// module id = 603
// module chunks = 0